import axios from "axios";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ruFlag from "../../assets/img/lang/Flag_of_Russia.png";
import tjFlag from "../../assets/img/lang/tj.png";
import enFlag from "../../assets/img/lang/us.png";
import logo from "../../assets/img/tajinvestSmall3.png";
import forumIcon from "../../assets/img/investforum1.png";
import "./style.css";
import Emblem from "../../assets/img/EmblemTj.svg";

const dropdownStyles = {
  navDropdown: {
    zIndex: 9999,
  },
  dropdownMenu: {
    zIndex: 10000,
  },
};

const languageMap = {
  1: { lang: "tj", flag: tjFlag },
  2: { lang: "ru", flag: ruFlag },
  3: { lang: "en", flag: enFlag },
};

const getInitialLanguageValue = () => {
  return parseInt(localStorage.getItem("selectedLanguageValue")) || 2;
};

const getInitialFlag = () => {
  return localStorage.getItem("currentFlag") || ruFlag;
};

const getInitialLangCode = () => {
  return localStorage.getItem("currentLang") || "ru";
};

const MenuExample = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedLanguageValue, setSelectedLanguageValue] = useState(
    getInitialLanguageValue(),
  );
  const [currentFlag, setCurrentFlag] = useState(getInitialFlag());
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    i18n.changeLanguage(getInitialLangCode());
  }, [i18n]);

  useEffect(() => {
    handleLanguageChange(selectedLanguageValue);
  }, [selectedLanguageValue]);

  useEffect(() => {
    const handleSearch = async (query) => {
      const langCode = languageMap[selectedLanguageValue].lang;
      if (query.length > 0) {
        try {
          const response = await axios.get(
            `https://api.tajinvest.tj/api/events/total-events?lang=${langCode}&search=${query}`,
            {
              headers: {
                accept: "text/plain",
                "api-version": "1.0",
              },
            },
          );
          setSearchResults(response.data.enttities);
        } catch (error) {
          console.error("Error fetching search results:", error);
        }
      } else {
        setSearchResults([]);
      }
    };

    handleSearch(searchQuery);
  }, [searchQuery, selectedLanguageValue]);

  const handleLanguageChange = (value) => {
    const selectedLang = languageMap[value].lang;
    const selectedFlag = languageMap[value].flag;

    setSelectedLanguageValue(value);
    setCurrentFlag(selectedFlag);
    localStorage.setItem("selectedLanguageValue", value);
    localStorage.setItem("currentFlag", selectedFlag);
    localStorage.setItem("currentLang", selectedLang);

    i18n.changeLanguage(selectedLang);
  };

  return (
    <Container>
      <Navbar expand="lg" className="mb-3">
        <Container
          fluid
          className="mt-4 custom-container d-flex align-items-center menutof3"
        >
          <div className="d-flex align-items-center me-auto">
            <Navbar.Brand as={Link} to="/" className="d-flex align-items-start">
              <div className="emblem-block">
                <img src={Emblem} alt="Emblem" className="emblem-img" />
                <span className="emblem-text">{t("emblemTitle")}</span>
              </div>
              <div className="emblem-block">
                <img src={logo} className="emblem-img" alt="Main logo" />
                <span className="emblem-text">{t("logoTitle")}</span>
                <span className="emblem-text">{t("logoTaj")}</span>
              </div>
              {/*               <div className="emblem-block">
                <img src={Emblem} alt="Emblem" className="emblem-img" />
                <span className="emblem-text">{t("emblemTitle")}</span>
              </div> */}
            </Navbar.Brand>

            {/* Иконка-ссылка на Insights Forum, рядом с логотипом */}
            {/* <Link
              to="/insights-forum"
              className="insights-forum-icon ms-2 d-flex align-items-center"
              title={t("investForum.menu")}
              style={{ overflow: "hidden" }}
            >
              <img
                src={forumIcon}
                alt="Insights Forum"
                //className="emblem-img"
                style={{
                  height: "70px",
                  width: "auto",
                  objectFit: "contain",
                  objectPosition: "left center",
                }}
              />
            </Link> */}
          </div>
          {/* bilol bitch */}
          <div className="d-flex align-items-center ms-auto">
            {/* {!isMobile && (
              <div
                className="eye-icon me-3 position-relative"
                onClick={() => setAccessibilityOpen(!accessibilityOpen)}
              >
                <FaEye className="eyeButton" />
                {accessibilityOpen && (
                  <div
                    className="dropdown-menu show accessibility-dropdown"
                    style={{ zIndex: 10000 }}
                  >
                    <AccessibilitySettings />
                  </div>
                )}
              </div>
            )} */}

            {!isMobile && (
              <div className="d-flex align-items-center">
                <NavDropdown
                  title={
                    <>
                      <img
                        src={currentFlag}
                        alt={languageMap[selectedLanguageValue].lang}
                        width="20"
                        height="15"
                        className="me-2"
                      />
                      <span style={{ color: "#ffffff" }}>
                        {languageMap[selectedLanguageValue].lang}
                      </span>
                    </>
                  }
                  id="navbarDropdown"
                  className="me-3 menutof3"
                  style={dropdownStyles.navDropdown}
                >
                  <div style={dropdownStyles.dropdownMenu}>
                    {Object.entries(languageMap).map(
                      ([value, { lang, flag }]) =>
                        parseInt(value) !== selectedLanguageValue && (
                          <NavDropdown.Item
                            key={value}
                            onClick={() =>
                              handleLanguageChange(parseInt(value))
                            }
                          >
                            <img
                              src={flag}
                              alt={lang}
                              width="20"
                              height="15"
                              className="me-2"
                            />
                            {lang}
                          </NavDropdown.Item>
                        ),
                    )}
                  </div>
                </NavDropdown>

                <div className="search-container me-3 position-relative">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder={t("search")}
                      className="me-2 menu-search"
                      aria-label={t("search")}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchResults.length > 0 && (
                      <div className="search-results" style={{ zIndex: 9999 }}>
                        {searchResults.map((item, index) => (
                          <div key={index} className="search-result-item">
                            {item.type === 4 && (
                              <Link
                                to={`/tenders/show/${item.id}`}
                                style={{ color: "#1c5252" }}
                              >
                                {item.title}
                              </Link>
                            )}
                            {item.type === 1 && (
                              <Link
                                to={`/news/show/${item.id}`}
                                style={{ color: "#1c5252" }}
                              >
                                {item.title}
                              </Link>
                            )}
                            {item.type === 3 && (
                              <Link
                                to={`/compi/show/${item.id}`}
                                style={{ color: "#1c5252" }}
                              >
                                {item.title}
                              </Link>
                            )}
                            {item.type === 2 && (
                              <Link
                                to={`/project/show/${item.id}`}
                                style={{ color: "#1c5252" }}
                              >
                                {item.title}
                              </Link>
                            )}
                            {item.type === 5 && (
                              <Link
                                to={`/job/show/${item.id}`}
                                style={{ color: "#1c5252" }}
                              >
                                {item.title}
                              </Link>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </Form>
                </div>
              </div>
            )}

            {isMobile ? (
              <button
                className={`burger-menu ${showOffcanvas ? "open" : ""}`}
                onClick={() => setShowOffcanvas(!showOffcanvas)}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            ) : (
              <NavDropdown
                title={t("menu")}
                id="dropdown-basic"
                className="menutof"
                variant="success"
              >
                <div style={{ zIndex: 9999 }}>
                  <NavDropdown.Item href="/">{t("home")}</NavDropdown.Item>
                  <NavDropdown.Item href="/maps">
                    {t("projectCoverageMapMenu")}
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/deatel">
                    DISCOVER TAJIKISTAN
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/structure">
                    {t("leadership")}
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/job">
                    {t("vacancies")}
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/news">{t("news")}</NavDropdown.Item>
                  <NavDropdown.Item href="/competitions">
                    {t("announcements")}
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/insights-forum">
                    {t("investForum.menu")}
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/forum-london">
                    Forum in London
                  </NavDropdown.Item>
                </div>
              </NavDropdown>
            )}
          </div>
        </Container>
      </Navbar>

      <Offcanvas
        show={showOffcanvas}
        onHide={() => setShowOffcanvas(false)}
        placement="end"
        className="offcanvas-style"
        style={{ zIndex: 5001 }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{t("menu")}</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <NavDropdown
            title={
              <>
                <img
                  src={currentFlag}
                  alt={languageMap[selectedLanguageValue].lang}
                  width="20"
                  height="15"
                  className="me-2"
                />
                {languageMap[selectedLanguageValue].lang}
              </>
            }
            id="navbarDropdownOffcanvas"
            style={{ zIndex: 5002 }}
          >
            {Object.entries(languageMap).map(
              ([value, { lang, flag }]) =>
                parseInt(value) !== selectedLanguageValue && (
                  <NavDropdown.Item
                    key={value}
                    onClick={() => handleLanguageChange(parseInt(value))}
                  >
                    <img
                      src={flag}
                      alt={lang}
                      width="20"
                      height="15"
                      className="me-2"
                    />
                    {lang}
                  </NavDropdown.Item>
                ),
            )}
          </NavDropdown>

          <Form className="d-flex mt-3 position-relative">
            <Form.Control
              type="search"
              placeholder={t("search")}
              className="me-2 menu-search__mini"
              aria-label={t("search")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchResults.length > 0 && (
              <div className="search-results" style={{ zIndex: 5003 }}>
                {searchResults.map((item, index) => (
                  <div key={index} className="search-result-item">
                    {item.type === 4 && (
                      <Link
                        to={`/tenders/show/${item.id}`}
                        style={{ color: "#1c5252" }}
                      >
                        {item.title}
                      </Link>
                    )}
                    {item.type === 1 && (
                      <Link
                        to={`/news/show/${item.id}`}
                        style={{ color: "#1c5252" }}
                      >
                        {item.title}
                      </Link>
                    )}
                    {item.type === 3 && (
                      <Link
                        to={`/compi/show/${item.id}`}
                        style={{ color: "#1c5252" }}
                      >
                        {item.title}
                      </Link>
                    )}
                    {item.type === 2 && (
                      <Link
                        to={`/project/show/${item.id}`}
                        style={{ color: "#1c5252" }}
                      >
                        {item.title}
                      </Link>
                    )}
                    {item.type === 5 && (
                      <Link
                        to={`/job/show/${item.id}`}
                        style={{ color: "#1c5252" }}
                      >
                        {item.title}
                      </Link>
                    )}
                  </div>
                ))}
              </div>
            )}
          </Form>

          <Nav className="flex-column mt-3">
            <Nav.Link href="/">{t("home")}</Nav.Link>
            <Nav.Link href="/maps">{t("projectCoverageMapMenu")}</Nav.Link>
            <Nav.Link href="/deatel">DISCOVER TAJIKISTAN</Nav.Link>
            <Nav.Link href="/structure">{t("leadership")}</Nav.Link>
            <Nav.Link href="/job">{t("vacancies")}</Nav.Link>
            <Nav.Link href="/news">{t("news")}</Nav.Link>
            <Nav.Link href="/competitions">{t("announcements")}</Nav.Link>
            <Nav.Link href="/insights-forum">{t("investForum.menu")}</Nav.Link>
            <Nav.Link href="/forum-london">Forum in London</Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
};

export default MenuExample;
